/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListBazaarItems200ResponseDataInner } from './ListBazaarItems200ResponseDataInner';
import {
    ListBazaarItems200ResponseDataInnerFromJSON,
    ListBazaarItems200ResponseDataInnerFromJSONTyped,
    ListBazaarItems200ResponseDataInnerToJSON,
    ListBazaarItems200ResponseDataInnerToJSONTyped,
} from './ListBazaarItems200ResponseDataInner';
import type { ListBazaarItems200ResponseMeta } from './ListBazaarItems200ResponseMeta';
import {
    ListBazaarItems200ResponseMetaFromJSON,
    ListBazaarItems200ResponseMetaFromJSONTyped,
    ListBazaarItems200ResponseMetaToJSON,
    ListBazaarItems200ResponseMetaToJSONTyped,
} from './ListBazaarItems200ResponseMeta';
import type { ListBazaarItems200ResponseLinks } from './ListBazaarItems200ResponseLinks';
import {
    ListBazaarItems200ResponseLinksFromJSON,
    ListBazaarItems200ResponseLinksFromJSONTyped,
    ListBazaarItems200ResponseLinksToJSON,
    ListBazaarItems200ResponseLinksToJSONTyped,
} from './ListBazaarItems200ResponseLinks';

/**
 * 
 * @export
 * @interface ListBazaarItems200Response
 */
export interface ListBazaarItems200Response {
    /**
     * 
     * @type {Array<ListBazaarItems200ResponseDataInner>}
     * @memberof ListBazaarItems200Response
     */
    data?: Array<ListBazaarItems200ResponseDataInner>;
    /**
     * 
     * @type {ListBazaarItems200ResponseLinks}
     * @memberof ListBazaarItems200Response
     */
    links?: ListBazaarItems200ResponseLinks;
    /**
     * 
     * @type {ListBazaarItems200ResponseMeta}
     * @memberof ListBazaarItems200Response
     */
    meta?: ListBazaarItems200ResponseMeta;
}

/**
 * Check if a given object implements the ListBazaarItems200Response interface.
 */
export function instanceOfListBazaarItems200Response(value: object): value is ListBazaarItems200Response {
    return true;
}

export function ListBazaarItems200ResponseFromJSON(json: any): ListBazaarItems200Response {
    return ListBazaarItems200ResponseFromJSONTyped(json, false);
}

export function ListBazaarItems200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListBazaarItems200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ListBazaarItems200ResponseDataInnerFromJSON)),
        'links': json['links'] == null ? undefined : ListBazaarItems200ResponseLinksFromJSON(json['links']),
        'meta': json['meta'] == null ? undefined : ListBazaarItems200ResponseMetaFromJSON(json['meta']),
    };
}

export function ListBazaarItems200ResponseToJSON(json: any): ListBazaarItems200Response {
    return ListBazaarItems200ResponseToJSONTyped(json, false);
}

export function ListBazaarItems200ResponseToJSONTyped(value?: ListBazaarItems200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ListBazaarItems200ResponseDataInnerToJSON)),
        'links': ListBazaarItems200ResponseLinksToJSON(value['links']),
        'meta': ListBazaarItems200ResponseMetaToJSON(value['meta']),
    };
}

